import { Routes } from '@angular/router';
import { optionalSessionGuard } from '@shared/guard/authentication.guard';

export const donationRoute: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/vitrine/vitrine.component').then(m => m.VitrineComponent),
    canActivate: [optionalSessionGuard],
    data: {
      title: 'Vitrine de Doações',
      fullscreen: true,
      search: false
    }
  }
];
